module.exports = __webpack_public_path__ + "img/vote-desc-title@2x.5d3bdf0a.png";